import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
import { Injectable } from '@angular/core';
import {ClaAudio} from "../../model/events";
import {Platform} from "ionic-angular";

@Injectable()
export class AudioProvider {

  private _gender: string = ClaAudio.NONE;

  public set gender(gender: string) {
    // Set gender
    this._gender = gender;

    // Load new files
    this.loadAudio();
  }

  public get gender(): string {
    return this._gender;
  }

  private fileType: string;
  constructor(public nativeAudio: NativeAudio,
              public platform: Platform) {
      //this.loadAudio();
  }

  private async loadAudio() {
    // Only load when in cordova
    if (!this.platform.is('cordova')) return;

    // Unload old files first
    try {
      await this.nativeAudio.unload(ClaAudio.BEGIN_SCAN);
      await this.nativeAudio.unload(ClaAudio.C1);
      await this.nativeAudio.unload(ClaAudio.C2);
      await this.nativeAudio.unload(ClaAudio.C3);
      await this.nativeAudio.unload(ClaAudio.C4);
      await this.nativeAudio.unload(ClaAudio.C5);
      await this.nativeAudio.unload(ClaAudio.C6);
      await this.nativeAudio.unload(ClaAudio.C7);
      await this.nativeAudio.unload(ClaAudio.T1);
      await this.nativeAudio.unload(ClaAudio.T2);
      await this.nativeAudio.unload(ClaAudio.T3);
      await this.nativeAudio.unload(ClaAudio.T4);
      await this.nativeAudio.unload(ClaAudio.T5);
      await this.nativeAudio.unload(ClaAudio.T6);
      await this.nativeAudio.unload(ClaAudio.T7);
      await this.nativeAudio.unload(ClaAudio.T8);
      await this.nativeAudio.unload(ClaAudio.T9);
      await this.nativeAudio.unload(ClaAudio.T10);
      await this.nativeAudio.unload(ClaAudio.T11);
      await this.nativeAudio.unload(ClaAudio.T12);
      await this.nativeAudio.unload(ClaAudio.L1);
      await this.nativeAudio.unload(ClaAudio.L2);
      await this.nativeAudio.unload(ClaAudio.L3);
      await this.nativeAudio.unload(ClaAudio.L4);
      await this.nativeAudio.unload(ClaAudio.L5);
      await this.nativeAudio.unload(ClaAudio.S1);
      await this.nativeAudio.unload(ClaAudio.LEFT);
      await this.nativeAudio.unload(ClaAudio.RIGHT);
      await this.nativeAudio.unload(ClaAudio.CLICK);
    } catch (e) {
    }

    // If we are set to none, just quit here
    if (this.gender == ClaAudio.NONE) return;
    let fileExt = this.gender === ClaAudio.MALE ? 'mp3' : 'wav';
    this.fileType = fileExt;
    // Load new files
    await this.nativeAudio.preloadSimple(ClaAudio.BEGIN_SCAN, `assets/sounds/${this.gender}/begin scan.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C1, `assets/sounds/${this.gender}/c1.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C2, `assets/sounds/${this.gender}/c2.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C3, `assets/sounds/${this.gender}/c3.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C4, `assets/sounds/${this.gender}/c4.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C5, `assets/sounds/${this.gender}/c5.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C6, `assets/sounds/${this.gender}/c6.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.C7, `assets/sounds/${this.gender}/c7.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T1, `assets/sounds/${this.gender}/t1.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T2, `assets/sounds/${this.gender}/t2.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T3, `assets/sounds/${this.gender}/t3.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T4, `assets/sounds/${this.gender}/t4.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T5, `assets/sounds/${this.gender}/t5.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T6, `assets/sounds/${this.gender}/t6.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T7, `assets/sounds/${this.gender}/t7.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T8, `assets/sounds/${this.gender}/t8.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T9, `assets/sounds/${this.gender}/t9.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T10, `assets/sounds/${this.gender}/t10.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T11, `assets/sounds/${this.gender}/t11.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.T12, `assets/sounds/${this.gender}/t12.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.L1, `assets/sounds/${this.gender}/l1.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.L2, `assets/sounds/${this.gender}/l2.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.L3, `assets/sounds/${this.gender}/l3.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.L4, `assets/sounds/${this.gender}/l4.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.L5, `assets/sounds/${this.gender}/l5.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.S1, `assets/sounds/${this.gender}/s1.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.LEFT, `assets/sounds/${this.gender}/left.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.RIGHT, `assets/sounds/${this.gender}/right.${fileExt}`);
    await this.nativeAudio.preloadSimple(ClaAudio.CLICK, `assets/sounds/click.wav`);
  }

  public async playAudio(clip: string, callback?) {
    if (this.gender == ClaAudio.NONE || !this.platform.is('cordova')) return;

      await this.nativeAudio.play(clip, callback);
  }

  public async playAudioDual(clip1: string, clip2: string) {
    if (this.gender == ClaAudio.NONE || !this.platform.is('cordova')) return;

    let isSafari = navigator.vendor ==  "Apple Computer, Inc.";

    if(!this.platform.is('ios') && !isSafari){
      await this.playBrowser(clip1, true, clip2);
    }else {
      await this.nativeAudio.play(clip1, () => {
        this.nativeAudio.play(clip2);
      });
    }
  }
   public playBrowser(clip, dual, clip2?, triple?, clip3?) {
      const aud = clip.replace('audio:', '');
      let URL = `assets/sounds/${this.gender}/${aud}.${this.fileType}`;
      if(aud === 'beginscan'){
        URL = `assets/sounds/${this.gender}/begin scan.${this.fileType}`
      }
      try{
        const context = new AudioContext();
        window.fetch(URL)
          .then(response => response.arrayBuffer())
          .then(arrayBuffer => context.decodeAudioData(arrayBuffer))
          .then(audioBuffer => {
            const source = context.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(context.destination);
            source.start();
            if(dual){
              source.addEventListener('ended', () => {
                this.playBrowser(clip2, false)
              })
            }
            if(triple){
              source.addEventListener('ended', () => {
                this.playBrowser(clip2, true, clip3)
              })
            }
          });
      }
      catch (e) {
        // to play something at least
         this.nativeAudio.play(clip);
        return;
      }
  }
}



// WEBPACK FOOTER //
// ./src/providers/audio/audio.ts